"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicProfilePermission = void 0;
var PublicProfilePermission;
(function (PublicProfilePermission) {
    PublicProfilePermission["socialLinks"] = "socialLinks";
    PublicProfilePermission["connectionList"] = "connectionList";
    PublicProfilePermission["summaryTable"] = "summaryTable";
    PublicProfilePermission["endorsedElements"] = "endorsedElements";
    PublicProfilePermission["adjectives"] = "adjectives";
    PublicProfilePermission["archetypes"] = "archetypes";
    PublicProfilePermission["otherUserSimilarities"] = "similarities";
})(PublicProfilePermission = exports.PublicProfilePermission || (exports.PublicProfilePermission = {}));
